var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "archive", staticStyle: { padding: "5px 10px" } },
      [
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("strong", [
            _c("span", { staticStyle: { "font-size": "18pt" } }, [
              _vm._v("이용약관"),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("p", [_vm._v("제1조 목적")]),
        _c("p", [
          _vm._v(
            "이 약관은 KODA DUCK GAMES(이하 ‘회사’)이 제공하는 게임 및 이에 부수된 제반 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다."
          ),
        ]),
        _c("p", [_vm._v("제2조 약관의 효력 및 변경")]),
        _c("p", [
          _vm._v(
            "1)회사는 이 약관의 내용을 회원이 알 수 있도록 게임 서비스 내 또는 그 연결화면, 게임 서비스 홈페이지에 게시합니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "합리적인 사유가 발생할 경우, 회사는 관계법령에 위배되지 않는 범위 내에서 본 약관을 개정할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있습니다. 회사가 본 약관을 개정하는 경우에는 변경사항은 서비스 초기화면과 홈페이지에 업데이트합니다. 회원에게 불리한 내용 또는 중요한 내용의 개정의 경우에는 30일 이상 사전 공지하거나 홈페이지에 온라인으로 공지합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "이 약관에 동의하는 것은 정기적으로 서비스 페이지를 방문하여 약관의 변경사항을 확인하는 것에 동의함을 의미합니다. 변경된 약관에 대한 정보를 알지 못해 발생하는 회원의 피해는 회사에서 책임지지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원은 변경된 약관에 동의하지 않을 경우 고객센터를 통해 회원 탈퇴(해지)를 요청할 수 있으며, 변경된 약관의 효력 발생일 이후에도 서비스를 계속 사용하거나 게임에 입장할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제3조 약관 외 준칙")]),
        _c("p", [
          _vm._v(
            "이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「게임산업진흥에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업 진흥법」 등 관련 법령 또는 상관례에 따릅니다."
          ),
        ]),
        _c("p", [_vm._v("제4조 용어의 정의")]),
        _c("p", [
          _vm._v("이 약관에서 사용하는 용어의 정의는 다음과 같습니다."),
        ]),
        _c("p", [
          _vm._v(
            "1)‘회사’란 온라인 또는 모바일 기기를 통해 서비스를 제공하는 사업자를 의미합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "2)‘회원’이란 이 약관에 따라 이용계약을 체결하고, 회사가 제공하는 서비스를 이용하는 자를 의미합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "3)‘콘텐츠’란 디바이스 등을 통하여 이용할 수 있도록 회사가 제공하는 모든 게임 및 네트워크 서비스, 애플리케이션, 게임 머니 및 게임 아이템 등 서비스와 관련되어 디지털 방식으로 제작된 내용물 일체를 말합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "4)‘디바이스’란 콘텐츠를 다운로드하거나 설치하여 사용할 수 있는 휴대폰, 스마트폰, PDA, 태블릿, PC등의 기기를 말합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "5)‘이용계약’이라 함은 서비스를 제공받기 위하여 회사와 체결하는 계약을 말합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "6)‘회원 ID’란 회원의 식별과 회원의 서비스를 이용을 위해 만드는 영어문자,수자 등의 조합입니다. 회원이 선정하고 회사가 부여하는 규칙으로 회원가입을 할 수 있고 회원 ID는 3-15자리, 앞머리는 반드시 문자여야 하며 문자와 숫자로 조합할 수 있습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "7)‘계정정보’란 회원의 계정, 비밀번호, 성명 등 회원이 회사에 제공한 일반정보, 기기정보, 게임이용정보 (캐릭터 정보, 아이템, 레벨 등), 이용요금 결제 정보 등을 통칭합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "‘비밀번호’란 회원이 부여받은 계정과 일치되는 회원임을 확인하고 회원의 정보 및 권익보호를 위해 회원 자신이 선정하여 비밀로 관리하는 문자, 숫자 또는 특수문자의 조합을 의미합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "8)‘게시물’이란 회원이 서비스를 이용함에 있어 회원이 게시한 문자, 문서, 그림, 음성, 영상 또는 이들의 조합으로 이루어진 모든 정보를 말합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "9)‘해지’란 회사 또는 회원이 이용계약을 해약하는 것을 말합니다."
          ),
        ]),
        _c("p", [_vm._v("제5조 서비스 이용계약의 성립")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "이용계약은 회원이 본 이용약관 내용에 대한 동의 또는 회사의 게임을 다운로드하거나, 이용하여 콘텐츠를 이용하는 경우 이 약관에 동의하며 해당 이용약관은 이후 어떤 변경이든 가능한 것으로 간주합니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "2.본 이용 약관에 대한 동의는 해당 회원가입 페이지의 ‘동의함’ 버튼을 누름으로서 이 약관에 동의하는 것으로 간주됩니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "3.회사는 회원에게 실명 확인 및 본인 인증을 요청할 수 있으며, 그 절차와 방식은 관계법령에 따릅니다."
          ),
        ]),
        _c("p", [_vm._v("제6조 서비스 이용 신청")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "서비스를 이용하고자 하는 회원은 회사에서 요청하는 정보(휴대폰 전화번호, E-MAIL 등)를 제공해 보다 편리하게 회원의 계정 비밀번호를 찾게 합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원 또는 회원으로 가입하고자 하는 자는 반드시 회사가 제공하는 본인확인 방법을 통하여 서비스를 이용할 수 있으며, 본인 명의로 등록하지 않은 사용자는 일체의 권리를 주장할 수 없습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "2)타인의 정보(아이핀 및 휴대폰 정보 등)를 도용하여 이용 신청을 한 회원의 모든 ID는 확인 되는 즉시 삭제됩니다."
            ),
          ]),
          _c("li", [_vm._v("제7조 개인정보의 보호 및 사용")]),
          _c("li", [
            _vm._v(
              "회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력하며, 개인 정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침에 따릅니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "단, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "서비스의 특성에 따라 회원의 별명, 사진 등 자신을 소개하는 글이 공개될 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제8조 이용 신청의 제한")]),
        _c("p", [
          _vm._v(
            "회원은 다음 각 호에 해당하는 행위를 하여서는 안되며, 해당 행위를 하는 경우에 회사는 회원의 서비스 이용 제한(계정정지를 포함 하나 한정되지 않고 게임 사용을 제한하는 등 방식), 관련 정보(글, 사진, 영상 등) 삭제 및 기타의 조치를 포함한 이용 제한 조치를 가할 수 있습니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v("각종 신청, 변경, 등록 시 허위의 내용을 등록하는 행위"),
          ]),
          _c("li", [_vm._v("타인의 정보를 도용한 행위")]),
          _c("li", [
            _vm._v(
              "회사로부터 특별한 권리를 받지 않고 회사의 프로그램을 변경하거나, 회사의 서버를 해킹하거나 웹사이트 또는 게시된 정보의 일부분 또는 전체를 임의로 변경하거나, 회사의 서비스를 비정상적인 방법으로 사용하는 행위"
            ),
          ]),
          _c("li", [_vm._v("회사 프로그램의 버그를 악용하는 행위")]),
          _c("li", [
            _vm._v(
              "정상적이지 아니한 방법으로 사이버 자산(ID, 캐릭터, 아이템, 게임 내 머니 등)을 취득, 양도 또는 매매하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v("서비스에 위해를 가하거나 서비스를 고의로 방해하는 행위"),
          ]),
          _c("li", [
            _vm._v(
              "회사의 사전 승낙 없이 서비스를 이용하여 영업활동을 하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "본 서비스를 통해 얻은 정보를 회사의 사전 승낙 없이 서비스 이용 외의 목적으로 복제하거나, 이를 출판 및 방송 등에 사용하거나, 제3자에게 제공하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "타인의 특허, 상표, 영업비밀, 저작권, 기타 지적재산권을 침해하는 내용을 전송, 게시 또는 기타의 방법으로 타인에게 유포하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "청소년보호법 또는 위반되는 저속, 음란한 내용의 정보, 문장, 도형, 음향, 동영상을 전송, 게시 또는 기타의 방법으로 타인에게 유포하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "심히 모욕적이거나 개인신상에 대한 내용이어서 타인의 명예나 프라이버시를 침해할 수 있는 내용을 전송, 게시 또는 기타의 방법으로 타인에게 유포하는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "다른 회원을 희롱 또는 위협하거나, 특정 회원에게 지속적으로 고통 또는 불편을 주는 행위"
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사의 승인을 받지 않고 다른 사용자의 개인정보를 수집 또는 저장하는 행위"
            ),
          ]),
          _c("li", [_vm._v("범죄와 결부된다고 객관적으로 판단되는 행위")]),
          _c("li", [
            _vm._v(
              "불법 프로그램을 사용하는 것을 홍보하거나,프리 서버,트로이 목마 등 관련된 내용을 유포하는 행위"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "KODA DUCK GAMES이 합당하지 않다고 판단되는 혹은 KODA DUCK GAMES에서 인가하지 않은 프로그램, 문건 등을 배포하는 행위"
          ),
        ]),
        _c("ol", { attrs: { start: "16" } }, [
          _c("li", [_vm._v("기타 관계 법령에 위배되는 행위")]),
        ]),
        _c("p", [_vm._v("제9조 회사의 의무")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 관련법과 본 약관에서 금지하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "3)회사는 회원의 개인정보보호를 위한 보안 의무를 게을리하지 않습니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우에는 회원에게 그 사유와 처리 일정을 통보하여야 합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제10조 회원의 의무")]),
        _c("p", [
          _vm._v(
            "1)회원은 본 약관에서 규정하는 사항과 기타 회사가 정한 제반 규정, 회사가 공지하는 사항을 준수하여야 합니다. 또한 회원은 회사의 업무에 방해가 되는 행위, 회사의 명예를 손상시키는 행위를 해서는 안 됩니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원은 청소년보호법 등 관계 법령을 준수하여야 합니다. 회원이 청소년 보호법 등 관계 법령을 위반한 경우는 해당 법령에 의거 처벌을 받게 됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원은 회사의 사전 승낙 없이 서비스를 이용하여 영업 활동을 할 수 없으며, 그 영업 활동의 결과에 대한 책임은 회원에게 있습니다. 또한 회원이 이와 같은 영업 활동으로 회사에 손해를 끼칠 경우, 회사는 해당 회원에 대해 서비스 이용 제한(계정정지를 포함 하나 한정되지 않고 게임사용을 제한하는 등 방식) 및 적법한 절차를 거쳐 손해 배상 등을 청구할 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제11조 서비스 이용")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 홈페이지 또는 개별 서비스 관련 홈페이지에 공지하거나 회원에게 이를 고지합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 불가능할 경우, 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다. 다만 이 경우 그 사유 및 기간 등을 회원에게 서비스 홈페이지를 통해 고지합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 스마트 기기를 위한 전용 애플리케이션 또는 네트워크를 이용하여 서비스를 제공하며, 회원은 애플리케이션을 다운로드 하여 설치하거나 네트워크를 이용하여 무료 또는 유료로 서비스를 이용할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용 가능하며 네트워크를 통해 애플리케이션 다운로드 또는 서비스를 이용하는 경우 가입한 이동통신사에서 정한 별도의 요금이 발생할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "다운로드 하여 설치한 애플리케이션 또는 네트워크 서비스를 통해 이용하는 서비스의 경우 스마트 기기 또는 이동통신사의 특성에 맞도록 제공되며 스마트 기기의 변경, 번호 변경 및 해외 로밍의 경우 콘텐츠의 전부 또는 일부 기능을 이용할 수 없으며 이 경우 회사는 어떠한 책임도 부담하지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 관련 법령, 정부 정책 등에 따라 서비스 또는 회원에 따라 서비스 이용시간을 제한할 수 있으며, 이러한 제한 사항 및 제한에 따라 발생하는 게임 이용 관련 제반 사항에 대해서는 회사가 책임을 부담하지 않습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제12조 서비스의 변경 및 중지")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 운영상 또는 기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다. 변경될 서비스의 내용 및 제공일자 등에 대해서는 콘텐츠 실행 후 초기화면과 홈페이지에 통지합니다. 단, 회사가 사전에 통지할 수 없는 치명적인 버그 발생, 서버기기 결함, 긴급 보안 문제 해결 등의 부득이한 사정이 있는 경우는 사후 홈페이지에 공지할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 시장 환경의 변화, 기술적 필요, 개별 서비스 회원의 선호 감소, 기타 게임의 기획이나 운영상 또는 회사의 긴박한 상황 등에 의해 서비스 전부를 중단할 필요가 있는 경우 30일 전에 콘텐츠 실행 후 초기화면, 게임 내 공지 혹은 회사 홈페이지에 이를 공지하고 서비스의 제공을 중단할 수 있습니다. 회사가 서비스를 중단하는 경우 회원은 무료 서비스, 사용 기간이 남아 있지 않는 유료 서비스 및 유료 아이템, 계속적 유료 이용 계약에 대해 환불 및 손해배상을 청구할 수 없습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 다음 각호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "i) 전시, 사변, 천재지변 또는 국가비상 사태 등 불가항력적인 사유가 있는 경우"
            ),
          ]),
          _c("li", [
            _vm._v(
              "ii) 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v("iii) 서비스용 설비의 보수 등 공사로 인한 부득이한 경우"),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v("iv) 회사의 제반 사정으로 서비스를 할 수 없는 경우"),
          ]),
          _c("li", [
            _vm._v(
              "회사는 서비스의 변경 및 중지로 발생하는 문제에 대해서는 책임을 지지 않습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제13조 회원번호 관리")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원ID와 비밀번호에 관한 모든 관리 책임은 회원에게 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "i) 회사는 회원ID에 의하여 제반 회원 관리 업무를 수행함으로 회원이 회원ID 비밀번호를 변경하고자 하는 경우 회사가 인정할만한 사유가 있어야만 합니다.회원ID는 변경할 수 없습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "ii) 회원이 등록한 회원ID 및 비밀번호에 의하여 발생되는 사용상의 과실 또는 제 3자에 의한 부정사용 등에 대한 모든 책임은 해당 회원에게 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제14조 유료 콘텐츠 구매, 사용기간 및 이용")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원은 서비스를 사용하고 있는 단말기의 종류에 따른 결제 운영정책에 따라 유료 콘텐츠를 구매할 수 있으며, 해당 결제 정책의 차이로 인해 결제 금액의 차이가 발생할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "게임 서비스 내에서 회원이 구매한 유료 콘텐츠는 해당 게임 서비스 애플리케이션을 다운로드하거나 설치한 단말기에서만 이용할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "사용기간이 별도로 명시된 유료 콘텐츠의 경우는 구매 시 명시된 사용 기간에 따릅니다. 제12조 제2항에따라 서비스 중단이 이루러지는 경우 기간의 정함이 없는 유료 콘텐츠의 사용 기간은 서비스 중단 공지 시 공지된 서비스의 중단일까지로 합니다. 회원은 회사가 정하여 별도로 고지한 방법 이외에는 유료 콘텐츠를 회원 본인의 계정에서만 이용할 수 있으며, 제 3자에게 양도, 대여, 매매할 수 없습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제15조 대금결제")]),
        _c("p", [
          _vm._v(
            "1)콘텐츠에 대한 구매 대금은 원칙적으로 이동통신사와 애플리케이션 스토어 등에서 정하는 정책, 방법 등에 따라 부과되며 납부 방법 역시 정해진 방법에 따라 납부해야 합니다. 회사 및 결제 업체의 정책, 정부의 방침 등에 따라 각 결제 수단 별로 한도가 부여 또는 조정될 수 있습니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원이 단말기 및 오픈 마켓의 비밀 번호 설정 기능 등을 이용하지 않거나 부주의하게 노출하여 발생하는 제3자의 결제에 대하여는 회사가 어떠한 책임도 부담하지 않습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제16조 청약 철회 및 구매 대금의 환불")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원이 구매한 유료 콘텐츠는 계약 체결일 또는 유료 콘텐츠 이용 가능일로부터 7일 이내 미사용 시 청약철회를 할 수 있으며, 회원이 청약철회를 한 경우 회사는 지체 없이 회원에게 지급된 유료 아이템을 회수 또는 삭제합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "다음과 같은 경우 유료 콘텐츠의 청약 철회가 제한되며 회사는 청약 철회가 제한되는 유료 콘텐츠에 대해서 결제 전에 청약철회가 제한됨을 표시합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "i) 구매 후 즉시 사용이 시작되거나 즉시 애플리케이션에 적용되는 아이템의 경우"
            ),
          ]),
          _c("li", [
            _vm._v(
              "ii) 애플리케이션의 정상적인 이용과정에서 결제 없이 획득한 아이템의 경우"
            ),
          ]),
        ]),
        _c("p", [_vm._v("iii) 게임내 이벤트를 통하여 획득한 아이템의 경우")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "iv) 추가적인 혜택이 제공되는 아이템의 해당 추가 혜택의 경우"
            ),
          ]),
          _c("li", [
            _vm._v("v) 묶음 형으로 판매된 아이템의 일부가 사용된 경우"),
          ]),
          _c("li", [
            _vm._v(
              "vi) 개봉 행위를 사용으로 볼 수 있거나 개봉 시 효용이 결정되는 캡슐형/확률형 아이템의 경우"
            ),
          ]),
          _c("li", [
            _vm._v(
              "환불은 서비스를 사용하고 있는 단말기의 운영체제 종류에 따라 각 결제업체의 환불 운영정책에 따라 진행됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원이 실제 정상적인 구매내역이 기록되는 이용 대금의 결제를 통하지 않고, 게임 서비스 중에 보상으로 취득하거나, 회사가 내부 이벤트 혹은 외부 제휴 이벤트 등을 통하여 지급한 유료 콘텐츠는 환불하지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "청약철회 및 환불 등을 요구할 경우에는 회사 고객센터를 통해 별도의 개인 정보 취급 동의 과정을 거친 후 회사의 구매내역 확인에 의해 진행되며, 이 과정 중 플랫폼 사업자 또는 결제업체를 통해 구매내역을 확인하는 절차를 거친 다음 진행됩니다. 회사는 이 과정 중에서 회원의 정당한 철회 사유를 확인하기 위해 필요시 회원에게서 제공받은 정보를 통해 회원에게 연락하며 정확한 사실 확인을 할 수 있으며, 추가적으로 증빙을 요구할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "애플리케이션에서 판매되는 유료 콘텐츠를 미성년자가 법정대리인의 동의 없이 결제하는 경우, 미성년자 또는 법정대리인은 결제를 취소할 수 있습니다. 단, 미성년자의 유료 콘텐츠 결제가 법정대리인으로부터 처분을 허락 받은 재산의 범위 내에 있는 경우 또는 미성년자가 사술 등을 사용하여 성년자로 믿게 한 때에는 취소가 제한됩니다. 유료 콘텐츠 구매자가 미성년자인지 여부는 결제가 진행된 단말기 또는 신용카드 등 결제 수단의 명의자를 기준으로 판단됩니다. 미성년자 결제취소를 요청하시는 경우 회사의 필요에 따라 미성년자 및 법정대리인을 증명할 수 있는 서류를 제출하여야 합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "애플리케이션을 통한 결제는 결제 업체가 제공하는 결제방식에 따릅니다. 따라서 결제 과정에서 과오금이 발생하는 경우 원칙적으로 결제업체에게 환급을 요청하여야 합니다. 단, 결제업체의 정책, 시스템에 따라 가능한 경우 회사가 결제 업체에게 필요한 환급절차의 이행을 요청할 수도 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "선물하기 기능을 통하여 이루어진 유료 콘텐츠에 하자가 있는 경우를 제외하고는 원칙적으로 결제 취소 및 환급이 불가하며, 유료 콘텐츠의 하자로 인한 환급은 선물을 보낸 회원에 한하여 가능합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원으로부터 환불에 필요한 관련서류를 받은 날로부터 최대한 조속한 시일 내에 환불을 완료하도록 노력합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제17조 계약 해지 및 변경")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 회원이 서비스 이용 내용에 있어서 다음 각호에 해당하는 경우 회사의 이용제한 규정에 따라 이용제한 및 이용 계약을 해지할 수 있습니다."
            ),
          ]),
          _c("li", [_vm._v("i) 서비스 신청 시에 허위 내용을 등록한 경우")]),
          _c("li", [_vm._v("ii) 서비스 운영을 고의로 방해한 경우")]),
        ]),
        _c("p", [
          _vm._v("iii) 타인의 서비스 아이디 및 비밀번호를 도용한 경우"),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "iv) 서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 광고성 정보를 전송하는 경우"
            ),
          ]),
          _c("li", [
            _vm._v(
              "v) 회사 및 회원에게 피해를 유발시키는 컴퓨터 바이러스 프로그램 등을 유포하는 경우"
            ),
          ]),
          _c("li", [_vm._v("vi) 객관적으로 범죄행동이라고 판단되는 경우")]),
        ]),
        _c("p", [
          _vm._v(
            "vii) 불법프로그램을 사용하는 것을 홍보하거나,프리 서버,트로이 목마 등 관련된 내용을 유포하는 경우"
          ),
        ]),
        _c("p", [
          _vm._v(
            "viii) KODA DUCK GAMES이 합당하지 않다고 판단되는 혹은 KODA DUCK GAMES에서 인가하지 않은 프로그램, 문건 등을 배포하는 경우"
          ),
        ]),
        _c("ol", [_c("li", [_vm._v("ix) 그 외 서비스 정책에 위배되는 사항")])]),
        _c("p", [
          _vm._v(
            "2)전항의 규정에 따라 이용계약을 해지하거나 중단하는 경우 회원은 콘텐츠를 사용할 수 없으며, 콘텐츠 구매 대금은 반환 받을 수 없습니다."
          ),
        ]),
        _c("p", [_vm._v("제18조 정보의 수집")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 채팅, 게임 내 편지 등 게임서비스 내에서 회원간에 이루어지는 모든 통신 내용을 저장보관할 수 있습니다. 이 정보는 회사만이 보유합니다. 회사는 회원간의 분쟁 조정, 민원 처리, 게임 질서의 유지 또는 게임 서비스 개선을 위한 경우에 한하여, 제3자는 법령에 따라 권한이 부여된 경우에 한하여 이 정보를 열람할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사 또는 제3자가 제1항에 따라 채팅 정보를 열람할 경우 회사는 관련 법령에 따라 열람의 사유 및 범위를 해당 회원에게 고지합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 서비스의 원활하고 안정적인 운영 및 서비스 품질의 개선을 위하여 회원 PC 등 단말기 설정 및 사양 정보, 실행중인 프로그램 정보, 회원의 모바일 기기 정보(설정, 사양, 운영체제, 버전 등)를 수집∙활용할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 서비스 개선 및 회원 대상 서비스 소개 등을 위한 목적으로 회원에게 추가정보를 요청할 수 있습니다. 이 요청에 대해 회원은 승낙하거나 거절할 수 있으며, 회사가 이 요청을 할 경우에는 회원이 이 요청을 거절할 수 있다는 뜻을 함께 고지합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제19조 (이용자에 대한 게임 서비스 이용 제한)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "아래 규정 내용에 따라 회사는 이용자의 게임 서비스 이용을 제한할 수 있습니다. 이용 제한에 대한 구체적인 사유는 개별 게임 운영 정책에 따라 결정됩니다. 회사가 취할 수 있는 제재 조치:"
            ),
          ]),
          _c("li", [
            _vm._v(
              "i) 캐릭터 일부 권한 제재: 일정 기간 내 캐릭터의 채팅, 결제 등 권한 제재"
            ),
          ]),
          _c("li", [
            _vm._v(
              "ii) 캐릭터 이용 제재: 이용자의 캐릭터 이용을 일정 기간 혹은 영구적 제한"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "iii) 계정 이용 제재: 이용자의 계정 이용을 일정 기간 혹은 영구적 제한"
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "iv) 이용자 이용 제재: 게임 서비스 이용을 일정 기간 혹은 영구적 제한"
            ),
          ]),
          _c("li", [
            _vm._v(
              "이용자 본인의 이유로 이용이 제한될 경우 회사는 제한으로 인해 발생한 결제 내용 손실, 누적 포인트 소실 등의 문제를 배상하지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "이용자의 책임으로 인해 회사 혹은 제3자에게 손해가 발생할 경우 이용자는 이를 배상해야 할 책임을 지게 됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 아래 상황에 따라 조사가 끝나기 전에 해당 계정의 이용을 임시적으로 제한할 권한을 가집니다:"
            ),
          ]),
          _c("li", [
            _vm._v("i) 해킹을 당했거나 해커의 공격을 받아 신고가 들어온 계정"),
          ]),
          _c("li", [
            _vm._v(
              "ii) 불법 프로그램 사용 등의 불법 행위를 저지른 정황이 의심될 경우"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "iii) 각 조항에 따라 서비스 이용을 일시 중지해야 한다고 판단되는 경우"
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "위에 명시한 규정에 따라 회사는 조사가 끝난 뒤 규정을 위반하지 않았다고 판명된 이용자에 대해 게임 서비스 이용 기한을 연장해 줍니다. 하지만 위에 명시한 규정에 따라 위법 행위가 적발된 이용자에 대해선 이를 연장하지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "위법 행위에 기록되지 않은 사항이더라도 서비스 질서 위반 혹은 다른 이용자에게 안 좋은 영향을 끼쳤을 경우 회사는 이용자의 서비스 이용을 제한할 수 있으며, 이용자가 지속적으로 규칙을 위반할 경우 강력한 제재 조치를 취할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사가 정당한 사유로 제재를 취했을 경우 제재 혹은 계약 해제로 인한 이용자의 손실을 배상하지 않습니다. 아울러 회사는 결제 서비스와 관련된 잔액 및 잔여 기간 등의 잔여 서비스에 대해 보상 혹은 환불하지 않습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제20조 이용 제한의 이유 및 절차")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 규정 위반 행위의 내용, 정도, 횟수, 결과 등을 다방면적으로 고려하고 제한 이용의 구체적인 이유 및 절차에 따라 운영 정책을 결정합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 이용 제한 규정을 시행할 때 게임 서비스 화면 혹은 로딩 화면에 이를 공시하여 사전에 이를 이용자들에게 알립니다(긴급 조치 채택 시 사후 통지 가능)"
            ),
          ]),
          _c("li", [_vm._v("i) 이용 제한 이유")]),
          _c("li", [_vm._v("ii) 이용 제한 유형 및 시간")]),
        ]),
        _c("p", [_vm._v("iii) 이용 제한 이의 신청 방법")]),
        _c("p", [_vm._v("제21조 (이용 제한 관련 이의 신청 절차)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "이용자가 이용 제한에 반대 의견이 있을 경우 알림 공지 후 14일 내에 이용 제한 부인 이유에 대한 이의신청서를 서면, 이메일, 혹은 유사한 방법을 사용해 회사로 발송해야 합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 이의신청을 받은 날부터 15일 내에 이용자의 이이에 대한 서면, 이메일, 혹은 유사한 방법을 사용해 답장합니다. 만약 회사가 15일 내에 답장하기 어려울 경우 이용자에게 원인 및 관련 처리 일정을 전달합니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "2)회사는 상술 답장 내용에 따라 관련 조치를 취할 권한을 갖습니다."
          ),
        ]),
        _c("p", [_vm._v("제22조 (복구 정책)")]),
        _c("p", [
          _vm._v(
            "1)데이터 유실 등의 문제가 회사의 원인 때문이 아닌 것으로 확인되면 회사는 객관적으로 기록 데이터를 확인할 수 있는 범위 내에서 합리적인 방법을 통해 복구하기 위해 노력합니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "이용자가 고의 혹은 실수로 게임 내용을 사용하거나 데이터가 유실됐을 경우 이에 대한 복구가 제한될 수도 있습니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "2)이용자의 계정이 개인적인 소홀(타인에게 계정 정보 및 비밀번호 유출) 등으로 인해 해킹 당할 경우 이에 대한 복구가 제한될 수도 있습니다."
          ),
        ]),
        _c("p", [_vm._v("제23조 (협력 서비스)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 제3자 플랫폼과 협력하고 이용자에게 협력 서비스를 제공합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "협력 서비스를 이용하기 위해 이용자는 서비스 이용에 필요한 개인정보 제공에 동의해야 합니다. 동의하지 않을 경우 협력 서비스 이용이 제한될 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "협력 서비스는 이용자의 정보를 기반으로 제공하는 서비스입니다. 따라서 이용자가 서비스 자격을 상실 혹은 중지할 경우 협력 서비스 이용이 제한될 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제24조 (테스트 목적의 서비스)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 공식 서비스를 상용화하기 전에 이용자에 대한 테스트 목적의 테스트 서비스를 진행합니다. 테스트 대상, 시간 및 관련 내용은 관련 게임 서비스의 공지사항에서 따로 공지합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "테스트 서비스는 공식 서비스가 아닌 버그를 찾거나 혹은 시장성 및 재미 인증 등을 위한 비공식 서비스입니다. 테스트 기간에 발생한 게임 내부 장애 및 서비스 이용 불가 등에 대해 회사는 어떠한 책임도 지지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "테스트 서비스 기간에 서비스의 안정성을 보장하기 위해 게임 데이터에 대한 변경, 수정, 보충, 삭제 등이 진행됩니다. 회사는 이에 대해 복구할 의무를 가지지 않습니다. 또한, 테스트 서비스 중지 후 게임 화폐, 캐릭터 정보를 포함한 모든 테스트 서비스에서 사용한 기록은 모두 삭제되며, 복구되지 않습니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "4)귀하는 회사가 더욱 나은 정식 서비스를 제공하기 위해 테스트 기간에 수집한 정보들을 정식 서비스에 사용하는 것을 인지하고 동의합니다."
          ),
        ]),
        _c("p", [_vm._v("제25조 (계약 해지)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "이용자가 본 계약에서 금지 및/혹은 운영 정책에서 금지하는 행위 등을 하고 이용자의 행위가 계약을 지속할 수 없게 할 경우 회사는 서비스 이용 중지 혹은 본 계약을 해지할 권리를 갖습니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "3)전 규정에 따라 회사가 본 계약을 해지 혹은 중지할 경우 이용자는 기기에서 본 계약과 관련된 모든 다운로드 내용을 삭제해야 합니다. 그리고 이용자는 본 계약 서비스를 이용할 모든 권한을 상실합니다. 이로 인해 회사에 환불 혹은 손해배상을 신청할 수 없습니다."
          ),
        ]),
        _c("p", [_vm._v("제26조 (이용자에 대한 통지)")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사가 이용자에게 통지할 때 이용자의 이메일, 게임 서비스 내 우편, 문자(LMS/SMS), 커뮤니티 등 방식으로 통지할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사가 모든 이용자에게 통지해야 할 경우 회사는 게임 서비스 화면 혹은 로딩 화면, 커뮤니티 등에 공지 혹은 알림 창으로 대체하여 통지할 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제27조 광고의 제공")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 서비스의 운영과 관련하여 게임서비스 내에 광고를 게재할 수 있습니다. 또한 수신에 동의한 회원에 한하여 전자우편, 문자서비스(LMS/SMS), 푸시메시지(Push Notification) 등의 방법으로 광고성 정보를 전송할 수 있습니다. 이 경우 회원은 언제든지 수신을 거절할 수 있으며, 회사는 회원의 수신 거절 시 광고성 정보를 발송하지 아니합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사가 제공하는 서비스 중의 배너 또는 링크 등을 통해 타인이 제공하는 광고나 서비스에 연결될 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "제2항에 따라 타인이 제공하는 광고나 서비스에 연결될 경우 해당 영역에서 제공하는 서비스는 회사의 서비스 영역이 아니므로 회사가 신뢰성, 안정성 등을 보장하지 않으며, 그로 인한 회원의 손해에 대하여도 회사는 책임을 지지 않습니다. 다만, 회사가 고의 또는 중과실로 손해의 발생을 용이하게 하거나 손해 방지를 위한 조치를 취하지 아니한 경우에는 그러하지 아니합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제28조 저작권 귀속")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "게임서비스 내 회사가 제작한 콘텐츠에 대한 저작권 기타 지식재산권은 회사의 소유이며, 회사는 회원에게 이를 게임서비스와 관련하여 회사가 정한 조건 아래에서 이용할 수 있는 권한만을 부여합니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "4)회원은 회사가 제공하는 게임서비스를 이용함으로써 얻은 정보 중 회사 또는 제공업체에 지식재산권이 귀속된 정보를 회사 또는 제공업체의 사전승낙 없이 아래 각 호의 방법으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "i)복제, 전송, 출판, 배포, 방송 기타 방법에 의한 영리목적 이용"
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "ii) 기타 이 약관 또는 회사의 정책으로 금지하는 목적을 위한 이용"
            ),
          ]),
          _c("li", [
            _vm._v(
              "이 약관에 의한 게임서비스 이용계약이 종료될 경우 회원은 게임 클라이언트 등 제1항의 모든 콘텐츠를 즉시 삭제하거나 반환하여야 합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원은 게임 내에서 보여지거나 게임서비스와 관련하여 회원 또는 다른 이용자가 게임 클라이언트 또는 게임서비스를 통해 업로드 또는 전송하는 대화 텍스트를 포함한 커뮤니케이션, 이미지, 사운드 및 모든 자료 및 정보(이하 “이용자 콘텐츠”라 합니다)에 대하여 회사가 다음과 같은 방법과 조건으로 이용하는 것을 허락합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "i) 해당 이용자 콘텐츠를 이용, 편집 형식의 변경 및 기타 변형하는 것(공표, 복제, 공연, 전송, 배포, 방송, 2차적 저작물 작성 등 어떠한 형태로든 이용 가능하며, 이용기간과 지역에는 제한이 없음)"
            ),
          ]),
          _c("li", [
            _vm._v(
              "ii) 이용자 콘텐츠를 제작한 이용자의 사전 동의 없이 거래를 목적으로 이용자 콘텐츠를 판매, 대여, 양도하지 않음"
            ),
          ]),
          _c("li", [
            _vm._v(
              "게임 내에서 보여지지 않고 게임서비스와 일체화되지 않은 회원의 이용자 콘텐츠(예컨대, 일반게시판 등에서의 게시물)에 대하여 회사는 회원의 명시적인 동의 없이 이를 이용하지 않으며, 회원은 언제든지 이러한 이용자 콘텐츠를 삭제할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원이 게시하거나 등록하는 게임서비스 내의 게시물 및 게시 내용이 제12조에서 규정하는 금지행위에 해당한다고 판단하는 경우, 사전통지 없이 이를 삭제하거나 이동 또는 등록을 거부할 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "7)회사가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 회원은 회사에 해당 정보의 삭제 또는 반박 내용의 게재를 요청할 수 있습니다. 이 경우 회사는 신속하게 필요한 조치를 취하고 이를 신청인에게 통지합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "8)이 조는 회사가 게임서비스를 운영하는 동안 유효하며, 회원 탈퇴 후에도 지속적으로 적용됩니다."
          ),
        ]),
        _c("p", [_vm._v("제29조 손해배상")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 위반한 회원은 회사에 발생하는 손해를 배상하여야 합니다. 다만 회사에게 귀책사유가 있는 부분은 회사가 책임을 부담합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반 행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한- 각종 이의 제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 손해를 배상하여야 합니다. 단 회사에게 귀책사유가 있는 부분은 회사가 책임을 부담합니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "5)회사는 무료로 제공하는 서비스와 관련하여 발생하는 사항에 대하여는 어떠한 손해도 책임을 지지 않습니다. 단, 회사의 고의나 중과실로 인한 손해인 경우는 예외로 합니다."
          ),
        ]),
        _c("p", [_vm._v("제30조 면책 조항")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 전시, 사변, 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 기술적 결함 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 귀책사유로 인한 게임서비스의 중지, 이용장애 및 계약해지에 대하여 책임이 면제됩니다."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "6)회사는 기간통신 사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하여 회원에게 손해가 발생한 경우에 대해서 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "회사는 사전에 공지된 게임서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 게임서비스가 중지되거나 장애가 발생한 경우에 대해서 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 컴퓨터 환경으로 인하여 발생하는 제반 문제 또는 회사의 고의 또는 중대한 과실이 없는 네트워크 환경으로 인하여 발생하는 문제에 대해서 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원 또는 제3자가 게임서비스 내 또는 웹사이트 상에 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 대해서는 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원 상호간 또는 회원과 제3자간에 게임서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사가 제공하는 게임서비스 중 무료서비스의 경우에는 회사의 고의 또는 중대한 과실이 없는 한 회사는 손해배상을 하지 않습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "본 게임서비스 중 일부의 게임서비스는 다른 사업자가 제공하는 게임서비스를 통하여 제공될 수 있으며, 회사는 다른 사업자가 제공하는 게임서비스로 인하여 발생한 손해 등에 대해서는 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원이 게임서비스를 이용하며 기대하는 캐릭터, 경험치, 아이템 등의 결과를 얻지 못하거나 상실한 것에 대하여 책임을 지지 않으며, 게임서비스에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 게임상 사이버 자산(게임 머니), 등급/내공 손실에 대하여 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 컴퓨터 오류에 의한 손해가 발생한 경우 또는 신상정보 및 전자우편주소를 부정확하게 기재하거나 미기재하여 손해가 발생한 경우에 대하여 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 관련 법령, 정부 정책 등에 따라 게임서비스 또는 회원에 따라 게임서비스 이용시간 등을 제한할 수 있으며, 이러한 제한사항 및 제한에 따라 발생하는 게임서비스 이용 관련 제반 사항에 대해서는 책임이 면제됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원이 비밀번호 또는 인증수단을 소홀히 관리하거나 도용, 위조나 변조를 방지하기 위하여 충분한 주의를 기울이지 않아 발생하는 게임이용상의 손해 또는 제3자 결제에 대해 책임을 지지 않습니다. 다만, 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원이 모바일 기기의 변경, 모바일 기기의 번호 변경, 운영체제(OS) 버전의 변경, 해외 로밍, 통신사 변경 등으로 인해 콘텐츠 전부나 일부의 기능을 이용할 수 없는 경우 회사는 이에 대해 책임을 지지 않습니다. 다만, 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원이 회사가 제공하는 콘텐츠나 계정정보를 삭제한 경우 회사는 이에 대해 책임을 지지 않습니다. 다만, 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 임시회원(guest)의 서비스 이용으로 발생한 손해에 대해서는 책임을 지지 않습니다. 다만, 회사의 고의 또는 중과실에 의한 경우에는 그러하지 아니합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("제31조 재판권 및 준거법")]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있을 경우에는 해당 규정에 따릅니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사의 기타 유료 서비스 이용 회원의 경우 회사가 별도로 정한 약관 및 정책에 따릅니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 게임 소재 국가 법령에 정한 절차에 따른 법원을 관할 법원으로 합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v("KODA DUCK GAMES")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }